import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { Platform } from '@ionic/angular';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { CoreService } from '../../core/core/core.service';

declare var window;
declare var gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  public hubspotLoaded: boolean = false;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public platform: Platform,
    public core: CoreService,
    public auth: AuthService,
  ) {}

  /**
   * Tracks a google page event
   * @param category - {string} The event category
   * @param action - {string} The event action
   * @param label - {string} The event label
   * @param value - {number} The event value
   */
  trackEvent(category: string, action: string, label?: string, trackRUM: boolean = false): void {
    const eventName = category.toLowerCase().split(' ').join('_');
    gtag('event', eventName, {
      category,
      action,
      hh_environment: this.core.Active_server?.env,
      hh_bump_screen: this.auth.Active_bump_screen?.account,
      hh_user_id: this.auth.User_id,
    });

    if (trackRUM && datadogRum) {
      try {
        datadogRum.addUserAction(category, {
          event_action: {
            action: action,
            label: label,
          },
        });
      } catch (e) {
        // ignore
      }
    }
  }

  /**** HUBSPOT */

  /**
   * Loads the hubspot API
   */
  hubspotLoad(): void {
    if (window['loadHubspot']) {
      window['loadHubspot'](() => {
        this.hubspotLoaded = true;
      });
    }
  }

  /**
   * Shows the Hubspot Launcher
   */
  showHubspot = (cb): boolean => {
    if (window['showHSWidget']) {
      window['showHSWidget'](cb);
    } else {
      return cb(false);
    }
  };

  /**
   * Hides the Hubspot Launcher
   */
  hideHubspot = (): void => {
    if (window['hideHSWidget']) {
      window['hideHSWidget']();
    }
  };
}
